import { Container, CssBaseline } from '@mui/material'

export function EmptyPage({ text }: { text: string }) {
  return (
    <Container component="main" sx={{ fontSize: 35 }}>
      <CssBaseline />
      <div className="flex flex-col items-center w-full mt-[30%]">
        <img className="w-36 m-4" src="/empty.svg" alt="empty icon" />
        <p className="text-lg text-center w-[85%]">{text}</p>
      </div>
    </Container>
  )
}
